/**
 * Datasource management utility.
 * Store, retrieve, and modify datsource definitions using simple placeholders for dynamic parameters.  Placeholders can be configured with default values inline.
 * @name datasource-manager
 * @type {Object}
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([
            './lib/extend',
            './lib/Datasource',
            './lib/createDatasourceEnv'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./lib/extend'),
            require('./lib/Datasource'),
            require('./lib/createDatasourceEnv')
        );
    }
})(this, function (extend, Datasource, createDatasourceEnv) {
    var UNDEF;
    var EMPTY = '';
    var OBJECT = 'object';

    function DatasourceManager () {
        /**
         * Collection of configured datasources.
         * @type {Object}
         */
        this._datasources = {
            'defaults': {
                'namespace': 'default', // storage namespace
                'expires': 300, // seconds to expire from storage
                'timeout': 20,  // seconds to timeout request
                'retries': 1, // number of retries to attempt
                'priority': 2,
                'method': 'GET',
                'store': true // flag for storage (false to ignore expire, and skip storage)
            }
        };
        this.manageEnv = createDatasourceEnv();
    }

    DatasourceManager.prototype = {
        /**
         * Add one or more datasource definitions.
         * @param {mixed}   name    Datasource name or a collection of
         *                          definitions.
         * @param {object}  [options] If name is a string, options is a required
         *                            set of properties.
         * @return {boolean} Returns true if operation is successful.
         */
        add: function (name, options) {
            var _datasources = this._datasources;
            if (typeof name === OBJECT) {
                extend(_datasources, name); // multiple sources
                return true;
            }
            if (_datasources[name]) {
                return false;
            }
            _datasources[name] = options || {};
            return true;
        },

        /**
         * Remove a single datasource definition.
         * @param {string}  name    Name of the datasource to be removed.
         *                            set of properties.
         * @return {boolean} Returns true if operation is successful.
         */
        remove: function (name) {
            var _datasources = this._datasources;
            var datasource = _datasources[name];

            delete _datasources[name];
            delete this.manageEnv.cache[name];

            return datasource;
        },

        /**
         * Update an existing datasource definition.
         * @param  {string} name Name of datasource to update.
         * @param  {object} obj  Set of properties to override.
         */
        update: function (name, obj) {
            var _datasources = this._datasources;

            if (_datasources[name]) {
                extend(_datasources[name], obj);
            }
                // Delete previously cached compiled version if present.
            delete this.manageEnv.cache[name];
        },

        /**
         * Get a all available datasources as a collection.
         * @return {object}
         */
        getAll: function () {
            return this._datasources;
        },

        /**
         * Retrieve a single datasource, merge it's properties with defaults and return.
         * @param  {string} dataSourceName Datasource name to retrieve.
         * @return {object}                Compiled instance of Datasource
         */
        get: function (dataSourceName) {
            var _datasources = this._datasources;
            var dscache = this.manageEnv.cache;

            return dscache[dataSourceName] || (dscache[dataSourceName] = _datasources[dataSourceName]
                ? new Datasource(dataSourceName, _datasources, this.manageEnv)
                : new Datasource('datasource "' + dataSourceName + '" not found', _datasources, this.manageEnv));
        },

        setEnv: function (env) {
            return this.manageEnv.env = env;
        },

        getEnv: function () {
            return this.manageEnv.env;
        },

        // Expose the Datasource class for easier testing
        Datasource: Datasource,

        create: function () {
            return new DatasourceManager();
        }
    };

    return DatasourceManager;
});
